export default __webpack_public_path__ + "static/ds-cover-b1d49c3219f185ed9f8b6ae2f2ae946f.jpg";